
import {Vue, Component, Prop} from 'vue-property-decorator';
import { readUserProfile, readUserPromocodesList } from '@/store/main/getters';
import GiftInfoModal from '../GiftInfoModal.vue';
@Component({
  components: {
    GiftInfoModal
  }
})
export default class DexPNModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  public isModalClosed: boolean = false;
 
  public closeModal(isCreated: boolean) {
    this.isModalClosed = true;
    this.$emit("close-modal", isCreated);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
